import React, { useState } from "react";
import "../CSS/styles.css";
import { Link } from 'react-router-dom';
import m1 from "../../assets/m1.png";

const Intro = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="container py-5 inter">
      <Link to="/News" className="text-decoration-none">
        <div className="d-flex align-items-center">
          <div>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.99756 13.648L3.33203 8.98242L7.99756 4.31689" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12.6631 8.98242H3.33203" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div>
            <p className="ms-1 mb-0 fw-medium bc">Back to all articles</p>
          </div>
        </div>
      </Link>
      <div className="row py-5">
        <div className="col-lg-8 col-12">
          <h3 className="blc mb-0 fw-bold">Introduction</h3>
          <p className="mt-4 gc mb-0 lss">As we navigate through 2023, the cyber security landscape continues to evolve at an unprecedented pace. Organizations of all sizes face an increasingly complex array of threats that can compromise sensitive data, disrupt operations, and damage reputation. In this article, we'll examine the emerging cyber security threats of 2023 and provide practical strategies for protection.</p>
          <h2 className="mt-5 blc mb-0 fw-bold">Emerging Threats in 2023</h2>
          <p className="mt-4 gc mb-0">The cyber threat landscape in 2023 is characterized by several key trends:</p>
          <h3 className="blc mb-0 fw-bold mt-5">1. Advanced Ransomware Attacks</h3>
          <p className="mt-4 gc lss mb-0">Ransomware attacks have evolved from simple encryption-based extortion to sophisticated multi-faceted attacks. Today's ransomware operators employ double and triple extortion techniques, threatening not only to encrypt data but also to leak sensitive information and launch DDoS attacks if ransom demands aren't met.</p>
          <h3 className="blc mb-0 fw-bold mt-5">2. Supply Chain Vulnerabilities</h3>
          <p className="mt-4 gc lss mb-0">Attackers are increasingly targeting supply chain vulnerabilities to compromise multiple organizations through a single point of entry. These attacks can be particularly devastating as they leverage trusted relationships between organizations and their vendors.</p>
          <h3 className="blc mb-0 fw-bold mt-5">3. Cloud Security Challenges</h3>
          <p className="mt-4 gc lss mb-0">As organizations continue to migrate to cloud environments, misconfigured cloud services and inadequate security controls present significant risks. Cloud-native attacks are becoming more common as attackers develop techniques specifically targeting cloud infrastructure.</p>
          <h3 className="blc mb-0 fw-bold mt-5">4. AI-Powered Threats</h3>
          <p className="mt-4 gc lss mb-0">Artificial intelligence is now being leveraged by threat actors to create more convincing phishing campaigns, automate attacks, and evade detection systems. AI-generated deepfakes are increasingly being used in social engineering attacks.</p>
          <h1 className="mb-0 mt-5 pt-4 blc fw-bold">Protection Strategies</h1>
          <p className="mb-0 gc mt-4">To address these evolving threats, organizations should consider the following protection strategies:</p>
          <h3 className="mb-0 mt-5 blc fw-bold">1. Implement Zero Trust Architecture</h3>
          <p className="mb-0 gc mt-4 lss">A zero trust security model operates on the principle of "never trust, always verify." This approach requires all users, whether inside or outside the organization's network, to be authenticated, authorized, and continuously validated before being granted access to applications and data.</p>
          <h3 className="mb-0 mt-5 blc fw-bold">2. Enhance Supply Chain Security</h3>
          <p className="mb-0 gc mt-4 lss">Organizations should implement rigorous vendor risk assessment processes and continuous monitoring of third-party access. Contractual security requirements and regular security audits of vendors can help mitigate supply chain risks.</p>
          <h3 className="mb-0 mt-5 blc fw-bold">3. Strengthen Cloud Security Posture</h3>
          <p className="mb-0 gc mt-4 lss">OrgImplement cloud security posture management (CSPM) solutions to identify and remediate misconfigurations. Ensure proper identity and access management, data encryption, and network security controls across cloud environments.</p>
          <h3 className="mb-0 mt-5 blc fw-bold">4. Deploy Advanced Threat Detection</h3>
          <p className="mb-0 gc mt-4 lss">Utilize AI and machine learning-based security solutions to detect and respond to sophisticated threats. These technologies can identify anomalous behavior and potential threats that traditional signature-based approaches might miss.</p>
          <h3 className="mb-0 mt-5 blc fw-bold">5. Conduct Regular Security Training</h3>
          <p className="mb-0 gc mt-4 lss">Human error remains a significant factor in security breaches. Regular, engaging security awareness training can help employees recognize and respond appropriately to social engineering attempts and other threats.</p>
          <h1 className="mt-5 blc fw-bold">Conclusion</h1>
          <p className="mb-0 mt-4 gc lss">As cyber threats continue to evolve in complexity and impact, organizations must adopt proactive and comprehensive security strategies. By understanding the emerging threat landscape and implementing appropriate protection measures, organizations can enhance their resilience against cyber attacks in 2023 and beyond.</p>
          <p className="mb-0 mt-4 gc lss">TAMBRO's Cyber Security services provide comprehensive protection for your digital assets, systems, and data. Our team of security experts works with you to develop and implement tailored security strategies that align with your business objectives and risk profile.</p>
          <div className="mt-5">
            <hr />
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-7 col-12">
                <div className="d-flex align-items-center px-lg-3">
                  <p className="mb-0 gc">Tags:</p>
                  <button className="dd ms-3 p-2 fs-7 px-3 fw-medium">
                    cuber security
                  </button>
                  <button className="dd ms-3 p-2 fs-7 px-3 fw-medium">
                    threats
                  </button>
                  <button className="dd ms-3 p-2 fs-7 px-3 fw-medium">
                    digital security
                  </button>
                </div>
              </div>
              <div className="col-lg-5 col-12 ms-lg-auto justify-content-lg-end justify-content-center d-flex mt-lg-0 mt-3">
                <div className="d-flex ms-auto align-items-center justify-content-lg-end justify-content-center ms-lg-auto me-3">
                  <p className="mb-0 gc fw-medium me-2">Share</p>
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_65_15197)">
                      <path d="M14.022 2.06152H11.7734C10.7795 2.06152 9.82632 2.45635 9.12351 3.15916C8.42071 3.86196 8.02588 4.81517 8.02588 5.80908V8.05762H5.77734V11.0557H8.02588V17.0518H11.0239V11.0557H13.2725L14.022 8.05762H11.0239V5.80908C11.0239 5.6103 11.1029 5.41966 11.2435 5.2791C11.384 5.13854 11.5747 5.05957 11.7734 5.05957H14.022V2.06152Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_65_15197">
                        <rect width="17.9883" height="17.9883" fill="white" transform="translate(0.53125 0.5625)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-3">
                    <path d="M16.9971 3.56056C16.9971 3.56056 16.4724 5.13453 15.498 6.1089C16.6973 13.604 8.45264 19.0755 2.00684 14.8032C3.65576 14.8782 5.30469 14.3535 6.50391 13.3042C2.75635 12.1799 0.882568 7.75783 2.75635 4.31007C4.40527 6.2588 6.95361 7.38307 9.50195 7.30812C8.82739 4.16017 12.5 2.36134 14.7485 4.45997C15.573 4.45997 16.9971 3.56056 16.9971 3.56056Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_65_15203)">
                      <path d="M12.4766 6.55859C13.6693 6.55859 14.8131 7.03239 15.6565 7.87576C16.4998 8.71912 16.9736 9.86297 16.9736 11.0557V16.3022H13.9756V11.0557C13.9756 10.6581 13.8177 10.2768 13.5365 9.99569C13.2554 9.71457 12.8741 9.55664 12.4766 9.55664C12.079 9.55664 11.6977 9.71457 11.4166 9.99569C11.1355 10.2768 10.9775 10.6581 10.9775 11.0557V16.3022H7.97949V11.0557C7.97949 9.86297 8.45329 8.71912 9.29665 7.87576C10.14 7.03239 11.2839 6.55859 12.4766 6.55859Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.98145 7.30811H1.9834V16.3022H4.98145V7.30811Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3.48242 5.05957C4.31031 5.05957 4.98145 4.38843 4.98145 3.56055C4.98145 2.73266 4.31031 2.06152 3.48242 2.06152C2.65453 2.06152 1.9834 2.73266 1.9834 3.56055C1.9834 4.38843 2.65453 5.05957 3.48242 5.05957Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_65_15203">
                        <rect width="17.9883" height="17.9883" fill="white" transform="translate(0.484375 0.5625)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-3">
                    <g clip-path="url(#clip0_65_15208)">
                      <path d="M16.9502 5.80908L10.2113 10.1015C9.98265 10.2344 9.72291 10.3043 9.45845 10.3043C9.194 10.3043 8.93425 10.2344 8.70557 10.1015L1.95996 5.80908" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M15.4512 3.56055H3.45898C2.6311 3.56055 1.95996 4.23168 1.95996 5.05957V14.0537C1.95996 14.8816 2.6311 15.5527 3.45898 15.5527H15.4512C16.2791 15.5527 16.9502 14.8816 16.9502 14.0537V5.05957C16.9502 4.23168 16.2791 3.56055 15.4512 3.56055Z" stroke="#6B7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_65_15208">
                        <rect width="17.9883" height="17.9883" fill="white" transform="translate(0.460938 0.5625)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            <hr className="mb-0" />
          </div>
        </div>
        <div className="col-lg-4 col-12 ps-lg-4">
          <div className="container-or-table3 p-4 int2">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <img src={m1} alt="" className="img-fluid" width="100%" />
              </div>
              <div className="col-lg-8">
                <p className="mb-0 bc fw-medium">Michael Chen</p>
                <p className="gc2 fs-6-5 mb-0">Chief Technology Officer</p>
              </div>
            </div>
            <p className="gc mb-0 mt-3 lss">
              Expert in cyber security with years of experience helping organizations address complex challenges.
            </p>
          </div>
          <div className="mt-5 p-4 vbg bor int2">
            <h5 className="mb-0 bc fw-bold">Get Expert Advice</h5>
            <p className="mb-0 mt-3 gc">
              Interested in learning more about cyber security solutions for your organization?
            </p>
            <>
              <button
                className="talk px-4 fw-medium w-100 mt-4 py-2 nav-item fs-6-5 btn btn-primary"
                type="button"
                onClick={handleShow}
              >
                Contact Our Team
              </button>
            </>
          </div>
          <div className="mt-5">
            <h5 className="mb-0 bc fw-bold">Categories</h5>
            <p className="mb-0 gc mt-3">Risk Management</p>
            <p className="mb-0 gc mt-3">Crisis Management</p>
            <p className="mb-0 gc mt-3">Cyber Security</p>
            <p className="mb-0 gc mt-3">GIS</p>
            <p className="mb-0 gc mt-3">Digital Solutions</p>
            <p className="mb-0 gc mt-3">Training & Capacity Building</p>
          </div>
        </div>

        {/* Modal placed here outside above container div */}
        {showModal && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 1050,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-modal="true"
            role="dialog"
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              style={{ maxWidth: "26%" }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <h5 className="fw-semibold mb-0 bc">Let's Talk</h5>
                    <p className="gc fs-6-5 mb-0 mt-2">
                      We'd love to discuss your project. Fill out the form and our
                      experts will reach out.
                    </p>
                    <p className="gc mb-1 fs-7 mt-4">Name</p>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      className="w-100 custom-input py-2 ps-2"
                      placeholder="Your Name"
                    />
                    <p className="gc mb-1 fs-7 mt-3">Email</p>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      className="w-100 custom-input py-2 ps-2"
                      placeholder="your.email@example.com"
                    />
                    <p className="gc mb-1 fs-7 mt-3">Phone</p>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      className="w-100 custom-input py-2 ps-2"
                      placeholder="Your Phone Number"
                    />
                    <p className="gc mb-1 fs-7 mt-3">Service of Interest</p>
                    <select
                      name="Service"
                      className="w-100 ps-2 custom-input py-2"
                      id="service"
                    >
                      <option value="1">Select a service</option>
                      <option value="2">Risk Management</option>
                      <option value="3">Crisis Management</option>
                      <option value="4">Project Support</option>
                      <option value="5">Research & Analysis</option>
                      <option value="6">GIS</option>
                      <option value="7">Cyber Security</option>
                      <option value="8">Training & Capacity Building</option>
                      <option value="9">Digital Solutions</option>
                    </select>
                    <p className="gc mb-1 fs-7 mt-3">Message</p>
                    <div className="mb-3">
                      <textarea
                        className="form-control w-100 custom-input p-2"
                        id="exampleFormControlTextarea1"
                        placeholder="Tell us about your project or inquiry"
                        rows="3"
                      ></textarea>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="talk w-100 py-2 fw-medium fs-6-5"
                        onClick={handleClose}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Intro